import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  readonly workflowsEnabled =
    'workflowsEnabled' in environment && environment.workflowsEnabled === true;
}
